import type { MeterSpec, SubdivisionSpec } from '@tunasong/music-lib'
import { buildClickStabs } from '../player/click-engine.js'
import { useStabScheduler } from '../player/stab-scheduler.js'

export interface UseClickPlaybackProps {
  meter: MeterSpec | null
  subdivision?: SubdivisionSpec
  bpm: number
  /** Defaults to 4. */
  measures?: number
}

/**
 * Rhythm Trainer audition hook. Thin wrapper over `useStabScheduler` —
 * delegates the stab math to `buildClickStabs`. A null meter yields an empty
 * stab list (no-op play), so the host can mount the hook unconditionally
 * regardless of the active sub-mode.
 *
 * Spec: docs/superpowers/specs/2026-05-22-rhythm-trainer-v1-design.md §5.3
 */
export const useClickPlayback = (
  props: UseClickPlaybackProps
): { play: () => void; stop: () => void } => {
  const { play, stop } = useStabScheduler({
    buildStabs: () =>
      props.meter
        ? buildClickStabs({
            meter: props.meter,
            subdivision: props.subdivision,
            bpm: props.bpm,
            measures: props.measures,
          })
        : [],
  })
  return { play, stop }
}
